
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/musik/events",
      function () {
        return require("private-next-pages/musik/events.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/musik/events"])
      });
    }
  